import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { HttpService } from "src/app/share-modul/services/common/http-service";
import { environment } from "src/environments/environment";
import { AddOrEditHostModel } from "../../models/hosts/add-or-edit-host.model";
import { HostModel } from "../../models/hosts/host.model";

const VENUE_API = environment.apiURL + '/api/mng/Venue/';

@Injectable({
  providedIn: 'root'
})

export class HostService {

  //#region Fields
  //#endregion

  //#region Constructor
  constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
  }

  //#endregion

  //#region Public Methods
  listHostsByVenue(venueId: string) {
    var url = VENUE_API + "getallhosts?VenueId=" + venueId;
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  createHost(model: AddOrEditHostModel) {
    var url = VENUE_API + "createhost";
    return this._httpService.httpPost(url, model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  updateHost(model: AddOrEditHostModel) {
    var url = VENUE_API + "updatehost";
    return this._httpService.httpPost(url, model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  deactivateHost(hostId: string) {
    var url = VENUE_API + 'deactivatehost';
    return this._httpService.httpPost(url, {hostId})
      .pipe(map(resposne => {
        return resposne;
      }));
  }
  //#endregion
}
